import { initializeApp, FirebaseApp } from 'firebase/app';
import {
  Analytics,
  getAnalytics,
  logEvent as firebaseLogEvent,
  setUserId as firebaseSetUserId,
} from 'firebase/analytics';
import { FirebaseConfig } from './Firebase.types';
import { AnalyticsEventDefaultArgs } from '../Analytics/Event.types';
import { getOfflineIdFromStorage } from '../Analytics/utils/userIdSettings';

export class Firebase {
  public offlineId?: string;
  public analyticsInstance?: Analytics;
  private firebaseInstance?: FirebaseApp;
  public firebaseConfig?: FirebaseConfig;

  constructor() {
    this.offlineId = undefined;
    this.firebaseInstance = undefined;
    this.analyticsInstance = undefined;
    this.firebaseConfig = undefined;
  }

  public initializeFirebaseInstance(
    firebaseConfig: FirebaseConfig,
    instanceName: string
  ): void {
    this.firebaseInstance = initializeApp(firebaseConfig, instanceName);
    this.getAnalyticsService(this.firebaseInstance);

    this.offlineId = getOfflineIdFromStorage();
  }

  public getAnalyticsService(instance: FirebaseApp): void {
    this.analyticsInstance = getAnalytics(instance);
  }

  public setAnalyticsUserId(
    analytics: Analytics,
    userId: string | number
  ): void {
    if (!analytics) return;
    return firebaseSetUserId(analytics, `${userId}`);
  }

  public logEvent(...args: AnalyticsEventDefaultArgs): void {
    const offlineId = this.offlineId;

    const debug_mode = args[1]?.options?.debug_mode;

    const params = {
      offlineId,
      ...(debug_mode ? { debug_mode } : {}),
      ...args[1],
    };

    if (this.analyticsInstance) {
      return firebaseLogEvent(
        this.analyticsInstance,
        args[0] as string,
        params
      );
    }
  }
}
